import { Input } from '@shadcn/ui/components/ui/input';
import { useMastraRuntime } from '../../home/providers/mastra-runtime-provider';
import { useAssistantRuntime } from '@assistant-ui/react';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const ActionAgentPromptInput = () => {
    const { thread } = useAssistantRuntime();
    const [value, setValue] = useState('');
    const [searchParams] = useSearchParams();
    const threadId = searchParams.get('threadId') || undefined;
    const navigate = useNavigate();

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            thread.append(value);
            setValue('');
            navigate({
                pathname: '/new/actions-v2/chat',
                search: threadId ? '?threadId=' + threadId : '',
            });
        }
    };

    return (
        <Input
            placeholder="What do you want to do?"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
        />
    );
};
